module.exports = __webpack_public_path__ + "img/Icons-07.701f965e.png";